import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';

const Hero = ({ language }) => {
  const texts = {
    no: {
      title: 'Oppdag de perfekte oppskriftene med AI',
      subtitle: 'Få personlige, AI-genererte oppskrifter basert på dine ingredienser og smakspreferanser',
      cta: 'Kom i gang',
      poweredBy: 'Drevet av avansert kunstig intelligens'
    },
    en: {
      title: 'Discover Perfect Recipes with AI',
      subtitle: 'Get personalized, AI-generated recipes based on your ingredients and taste preferences',
      cta: 'Get Started',
      poweredBy: 'Powered by advanced artificial intelligence'
    }
  };

  const t = texts[language];

  return (
    <section id="section-1" className="relative py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {t.title}
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                {t.subtitle}
              </p>
            </div>

            {/* CTA Button */}
            <div className="flex justify-center">
              <a href="#section-2" className="inline-flex items-center px-8 py-4 bg-green-600 text-white rounded-xl font-semibold text-lg hover:bg-green-700 transition-colors duration-200 shadow-lg">
                <span>{t.cta}</span>
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </div>

            <div className="flex items-center space-x-2 text-green-600">
              <Sparkles className="w-5 h-5" />
              <span className="text-sm font-medium">{t.poweredBy}</span>
            </div>
          </div>

          {/* Right side - Hero Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="/images/hero-kitchen-fridge.png"
                alt="Modern kitchen with ingredients"
                className="w-full h-96 lg:h-[500px] object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent"></div>
            </div>
            
            {/* Floating AI Badge */}
            <div className="absolute -top-4 -right-4 bg-white rounded-full p-4 shadow-lg">
              <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                <Sparkles className="w-6 h-6 text-green-600" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
